<template>
  <div>
    <h5 class="text-primary"><i class="fas fas fa-boxes"></i> Produtos</h5>

    <!-- main col -->
    <div class="row">
      <!-- first col -->
      <div :class="`col-md-${isNfe ? 12 : 10}`">
        <!-- first internal row   -->
        <div class="row">
          <div class="col-md-6">
            <search-input
              :alias="'Produto'"
              :isLoading="productIsLoading"
              v-model="form.product_base_id.value"
              :displayedValue="form.product.value"
              :form="form"
              :name="'product_base_id'"
              @search="searchProduct($event)"
              :searchResult="searchProductResults"
              :ref="'searchProductInput'"
              @selected="setProductValue($event)"
            >
              <search-input-option
                v-for="(row, index) in searchProductResults.data"
                tabindex="0"
                :key="index"
                :index="index"
                @click="setProductValue(row, false)"
              >
                <div class="d-flex justify-content-between">
                  <div>
                    <small class="text-muted">{{ row.base_sku_id }}</small>
                    - {{ row.description }}
                    <br />
                    <small class="text-muted">{{ row.brand }} &nbsp;</small>
                  </div>
                  <div class="text-right">
                    <template v-if="enabledPolicePrice">
                      à vista {{ row.price_payment_immediate | decimal }}<br />
                      à prazo {{ row.price_payment_on_terms | decimal }}
                    </template>
                    <template v-else>
                      {{ row.price | decimal }}
                    </template>
                    <template v-if="disableEstoque">
                      <p>
                        <small class="text-muted"
                          >Estoque {{ row.stock | decimal }}</small
                        >
                      </p>
                    </template>
                  </div>
                </div>
              </search-input-option>
            </search-input>
          </div>

          <div class="col-6 col-md-2">
            <number-input
              v-model="form.quantity.value"
              :alias="'Quantidade'"
              :decimalPlaces="3"
            ></number-input>
          </div>

          <div class="col-6 col-md-2">
            <number-input
              v-model="form.price.value"
              :alias="'Preço'"
              :disabled="disableChangeTablePrice"
            ></number-input>
          </div>

          <div class="col-md-2">
            <number-input
              :value="total"
              :disabled="true"
              :alias="'Total'"
            ></number-input>
          </div>
        </div>
        <!-- second row -->
        <div class="row" v-if="isNfe">
          <div class="col-md-2">
            <text-input
              v-model="form.unit.value"
              :alias="'Unidade'"
            ></text-input>
          </div>
          <div class="col-md-4">
            <select-input
              v-model="form.csosn.value"
              :alias="'CSOSN'"
              :options="form.csosn.options"
            ></select-input>
          </div>

          <div class="col-md-2">
            <b-form-group label="CFOP" label-for="CFOP">
              <template #label>
                <span @dblclick="showLastCFOP = !showLastCFOP"> CFOP </span>
              </template>
              <b-form-input size="sm" id="CFOP" v-model="form.cfop.value" />
              <template #description>
                <span v-if="showLastCFOP && form.last_cfop.value">
                  <b-badge variant="primary">CFOP de Entrada</b-badge>
                  {{ form.last_cfop.value }}
                </span>
              </template>
            </b-form-group>
          </div>

          <div class="col-md-2">
            <text-input :alias="'CEST'" v-model="form.cest.value"></text-input>
          </div>

          <div class="col-md-2">
            <text-input v-model="form.ncm.value" :alias="'NCM'"></text-input>
          </div>
          <div class="col-md-2">
            <!-- <number-input :value="total" :disabled="true" :alias="'Total'"></number-input> -->
          </div>
        </div>
      </div>

      <!-- last col -->
      <div v-if="!isNfe" class="col-md-2">
        <div class="form-group">
          <label class="control-label">&nbsp;</label>
          <br />
          <button
            class="btn btn-block btn-sm btn-success"
            @click="comfirmProduct"
          >
            <i class="fas fa-arrow-down"></i>
            Adicionar
          </button>
        </div>
      </div>
    </div>
    <template v-if="isNfe">
      <hr />
      <div class="row">
        <div class="col-md-4">
          <select-input
            :options="form.modBC_ICMS.options"
            v-model="form.modBC_ICMS.value"
            :alias="'Modalidade  da Base Calc. ICMS'"
          />
        </div>
        <div class="col-md-2">
          <number-input
            :decimalPlaces="3"
            v-model="form.bcICMS.value"
            :alias="'Base Calc. ICMS'"
          />
        </div>
        <div class="col-md-2">
          <number-input
            :decimalPlaces="3"
            v-model="form.vICMS.value"
            :alias="'ICMS'"
          />
        </div>
        <div class="col-md-2">
          <number-input v-model="form.pICMS.value" :alias="'Alíq. ICMS'" />
        </div>
        <div class="col-md-4">
          <select-input
            :options="form.modBC_ICMSST.options"
            v-model="form.modBC_ICMSST.value"
            :alias="'Modalidade  da Base Calc. ICMS ST'"
          />
        </div>
        <div class="col-md-2">
          <number-input
            :decimalPlaces="3"
            v-model="form.bcICMSST.value"
            :alias="'Base Calc. ICMS ST'"
          />
        </div>

        <div class="col-md-2">
          <number-input
            :decimalPlaces="3"
            v-model="form.vICMSST.value"
            :alias="'ICMS ST'"
          />
        </div>

        <div class="col-md-2">
          <number-input v-model="form.pICMSST.value" :alias="'Alíq. ICMS ST'" />
        </div>
        <div class="col-md-2" />

        <div class="col-md-2">
          <number-input
            :decimalPlaces="3"
            v-model="form.bcIPI.value"
            :alias="'Base Calc. IPI'"
          />
        </div>
        <div class="col-md-2">
          <number-input
            :decimalPlaces="3"
            v-model="form.vIPI.value"
            :alias="'IPI'"
          />
        </div>

        <div class="col-md-2">
          <number-input v-model="form.pIPI.value" :alias="'Alíq. IPI'" />
        </div>

        <div class="col-md-2">
          <number-input
            :decimalPlaces="3"
            v-model="form.bcCOFINS.value"
            :alias="'Base Calc. COFINS'"
          />
        </div>
        <div class="col-md-2">
          <number-input
            :decimalPlaces="3"
            v-model="form.vCOFINS.value"
            :alias="'COFINS'"
          />
        </div>
        <div class="col-md-2">
          <number-input v-model="form.pCOFINS.value" :alias="'Alíq. COFINS'" />
        </div>

        <div class="col-md-2">
          <number-input v-model="form.bcPIS.value" :alias="form.bcPIS.label" />
        </div>
        <div class="col-md-2">
          <number-input v-model="form.vPIS.value" :alias="form.vPIS.label" />
        </div>

        <div class="col-md-2">
          <number-input v-model="form.pPIS.value" :alias="form.pPIS.label" />
        </div>
        <div class="col-md-4" />
        <div class="col-md-4">
          <number-input
            v-model="form.vBCSTRet.value"
            :alias="form.vBCSTRet.label"
          />
        </div>
        <div class="col-md-4">
          <number-input
            v-model="form.vICMSSTRet.value"
            :alias="form.vICMSSTRet.label"
          />
        </div>
        <div class="col-md-4">
          <number-input
            v-model="form.pRedBCST.value"
            :alias="form.pRedBCST.label"
          />
        </div>

        <div class="col-md-4">
          <number-input
            v-model="form.pMVAST.value"
            :alias="form.pMVAST.label"
          />
        </div>
        <div class="col-md-4">
          <number-input
            v-model="form.pICMSEfet.value"
            :alias="form.pICMSEfet.label"
          />
        </div>
        <div class="col-md-4">
          <number-input
            v-model="form.vICMSEfet.value"
            :alias="form.vICMSEfet.label"
          />
        </div>
        <div class="col-md-4">
          <number-input
            v-model="form.vICMSSubstituto.value"
            :alias="form.vICMSSubstituto.label"
          />
        </div>
        <div class="col-md-4">
          <number-input
            v-model="form.vBCFCPST.value"
            :alias="form.vBCFCPST.label"
          />
        </div>
        <div class="col-md-4">
          <number-input
            v-model="form.pFCPST.value"
            :alias="form.pFCPST.label"
          />
        </div>
        <div class="col-md-4">
          <number-input
            v-model="form.vFCPST.value"
            :alias="form.vFCPST.label"
          />
        </div>
        <div class="col-md-4">
          <number-input v-model="form.pST.value" :alias="form.pST.label" />
        </div>
        <div class="col-md-4">
          <number-input
            v-model="form.vBCFCPSTRet.value"
            :alias="form.vBCFCPSTRet.label"
          />
        </div>
        <div class="col-md-4">
          <number-input
            v-model="form.pFCPSTRet.value"
            :alias="form.pFCPSTRet.label"
          />
        </div>
        <div class="col-md-4">
          <number-input
            v-model="form.vFCPSTRet.value"
            :alias="form.vFCPSTRet.label"
          />
        </div>

        <div class="col-md-4">
          <number-input
            v-model="form.pRedBC.value"
            :alias="form.pRedBC.label"
          />
        </div>
        <div class="col-md-4">
          <number-input
            v-model="form.pRedBCEfet.value"
            :alias="form.pRedBCEfet.label"
          />
        </div>
        <div class="col-md-3">
          <number-input
            v-model="form.vBCEfet.value"
            :alias="form.vBCEfet.label"
          />
        </div>
      </div>
      <div class="row text-right">
        <div class="col-md-10"></div>
        <div class="col-md-2">
          <div class="form-group">
            <button
              class="btn btn-success btn-block btn-sm"
              @click="comfirmProduct()"
            >
              Adicionar
            </button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Form from "./../../mixins/Form.js";
import Filters from "./../../mixins/Filters.js";

export default {
  props: {
    value: {},

    isNfe: {
      default: false,
    },

    priceType: {
      default: "price",
    },

    hasPaymentMethodOnTerm: {
      default: false,
    },
  },

  data: function () {
    return {
      showLastCFOP: false,
      updateIndex: null,

      products: [],

      stockActive: {},

      form: new Form({
        product_base_id: {
          alias: "Produto",

          validate: {
            required: true,
          },
        },

        id: {
          default: null,
        },

        base_sku_id : {
          value : null
        },

        product: {
          value: null,
        },

        quantity: {
          value: 1,
        },

        table_price: {
          value: 0,
        },

        price: {
          value: 0,
        },

        cost: {
          value: 0,
        },

        discount: {
          value: 0,
        },

        addition: {
          value: 0,
        },

        shipping: {
          value: 0,
        },

        unit: {},

        ncm: {},

        cest: {},

        CST: { value: null },
        bcICMS: { value: 0 },
        modBC_ICMS: {
          value: null,
          options: {
            null: "",
            0: "Margem Valor Agregado %",
            1: "Pauta (Valor)",
            2: "Preço Tabelado Máximo",
            3: "Valor da Operação",
          },
        },
        vICMS: { value: 0 },
        pICMS: { value: 0 },

        modBC_ICMSST: {
          value: null,
          options: {
            null: "",
            0: "Preço tabelado ou máximo sugerido",
            1: "Lista Negativa (valor)",
            2: "Lista Positiva (valor);",
            3: "Lista Neutra (valor)",
            4: "Margem Valor Agregado (%)",
            5: "Pauta (valor)",
            6: " Valor da Operação (NT 2019.001)",
          },
        },
        bcICMSST: { value: 0 },
        vICMSST: { value: 0 },
        pICMSST: { value: 0 },

        bcIPI: { value: 0 },
        vIPI: { value: 0 },
        pIPI: { value: 0 },

        bcCOFINS: { value: 0 },
        vCOFINS: { value: 0 },
        pCOFINS: { value: 0 },

        csosn: {
          options: {
            "": "",
            101: "  101 | Tributada pelo Simples Nacional com permissão de crédito",
            102: "  102 | Tributada pelo Simples Nacional sem permissão de crédito",
            103: "  103 | Isenção do ICMS no Simples Nacional para faixa de receita bruta",
            201: "  201 | Tributada pelo Simples Nacional com permissão de crédito e com cobrança do ICMS por substituição tributária",
            202: "  202 | Tributada pelo Simples Nacional sem permissão de crédito e com cobrança do ICMS por substituição tributária",
            203: "  203 | Isenção do ICMS no Simples Nacional para faixa de receita bruta e com cobrança do ICMS por substituição tributária",
            300: "  300 | Imune",
            400: "  400 | Não tributada pelo Simples Nacional",
            500: "  500 | ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação",
            900: "  900 | Outros",
          },
        },

        cfop: {
          value: null,
        },
        last_cfop: {
          value: null,
        },
        bcPIS: {
          label: "Base Calc. PIS",
          value: 0,
        },
        pPIS: {
          label: "Alíq. PIS",
          value: 0,
        },
        vPIS: {
          label: "PIS",
          value: 0,
        },

        vBCSTRet: {
          label: "Valor da BC do ICMS ST retido",
          value: null,
        },
        vICMSSTRet: {
          label: "Valor do ICMS ST retido",
          value: null,
        },
        pRedBCST: {
          label: "Percentual da Redução de BC do ICMS ST",
          value: null,
        },
        pMVAST: {
          label: "Percentual da margem de valor Adicionado do ICMS ST ",
          value: null,
        },
        pICMSEfet: {
          label: "Alíquota do ICMS efetiva ",
          value: null,
        },
        vICMSEfet: {
          label: "Valor do ICMS efetivo",
          value: null,
        },
        vICMSSubstituto: {
          label: "Valor do ICMS próprio do Substituto ",
          value: null,
        },

        vBCFCPST: {
          label: "Valor da BC do FCP retido por ST",
          value: null,
        },
        pFCPST: {
          label: "Percentual do FCP retido por ST ",
          value: null,
        },
        vFCPST: {
          label: "Valor do FCP retido por ST",
          value: null,
        },

        pST: {
          label: "Alíquota suportada pelo Consumidor Final ",
          value: null,
        },
        vBCFCPSTRet: {
          label: "Valor da BC do FCP retido anteriormente",
          value: null,
        },
        pFCPSTRet: {
          label: "Percentual do FCP retido anteriormente por ST",
          value: null,
        },
        vFCPSTRet: {
          label: "Valor do FCP retido por ST",
          value: null,
        },

        pRedBC: {
          label: "Percentual da Redução de BC ",
          value: null,
        },
        pRedBCEfet: {
          label: "Percentual de redução da BC efetiva",
          value: null,
        },
        vBCEfet: {
          label: "Valor da BC efetiva",
          value: null,
        },
      }),

      weight: {},

      producstData: {},

      productIsLoading: false,

      searchProductResults: {},
    };
  },

  mounted() {
    this.products = this.value;
  },

  watch: {
    value(newValue, oldValue) {
      this.products = newValue;
    },

    priceType(val) {
      this.refreshPrice(val);
    },
  },

  computed: {
    total() {
      return this.form.quantity.value * this.form.price.value;
    },

    insertState() {
      return this.updateIndex == null;
    },

    disableChangeTablePrice() {
      return this.$store.state.company.order_disable_change_table_price != 0;
    },

    disableEstoque() {
      return this.$store.state.company.module_stock_active == 1;
    },

    enabledPolicePrice() {
      if (this.$store.state.company.product_payment_policy == 2) {
        return true;
      }
    },
  },

  methods: {
    searchProduct(params) {

      if (this.isEan13(params.text) && this.isEan13Balance(params.text)) {
        let description = this.productBalanceDescriptionEan13(params.text);

        let weight = this.quantityBalanceEan13(params.text);

        this.postSearch(description, params.page, true);
      } else {
        let description = params.text;

        this.postSearch(description, params.page, false);
      }
    },

    postSearch(text, page, typeSearch) {
       this.productIsLoading = true;
      axios
        .post(
          process.env.BASE_URL + "api/searchproductorder/select?page=" + page,
          {
            description: text,
          }
        )
        .then((response) => {
          this.searchProductResults = response.data;

          if (this.searchProductResults.data.length == 0) {
            this.$store.commit("showAlert", {
              message: "Produto não cadastrado",
              variant: "info",
            });
          }

          if (typeSearch) {
            this.setProductValue(this.searchProductResults.data[0], typeSearch);
          }

          this.productIsLoading = false;
        })
        .catch((error) => {
          this.productIsLoading = false;
          this.error = error;
        });
    },

    // set value for searchInput
    setProductValue(product, typeSearch) {
      this.form.id.value = product.id;

      this.form.product_base_id.value = product.id;

      this.form.base_sku_id.value = product.base_sku_id;

      this.form.product.value = product.description;

      this.form.table_price.value = product.price;

      this.form.cost.value = product.cost;

      this.form.price.value = this.getPrice(product);

      this.form.unit.value = product.unit;

      this.form.csosn.value = product.csosn;

      this.form.ncm.value = product.ncm;

      this.form.cest.value = product.cest;

      this.form.last_cfop.value = product.last_cfop;
      this.form.discount.value = 0;

      this.form.addition.value = 0;

      this.form.shipping.value = 0;

      this.producstData[product.id] = product;

      if (typeSearch) {
        this.form.quantity.value = this.weight;

        this.comfirmProduct();
      }
    },

    getPrice(product) {
      return product[this.priceType];
    },

    refreshPrice(priceType) {
      for (let index in this.products) {
        this.products[index].price = this.producstData[
          this.products[index].product_base_id
        ][priceType];
      }

      if (this.form.id.value != null && this.form.id.value != "") {
        this.form.price.value = this.producstData[
          this.form.product_base_id.value
        ][priceType];
      }
    },

    comfirmProduct() {
      if (!this.form.isValid()) {
        return;
      }

      if (this.insertState) {
        this.insertProduct();
      } else {
        this.updateProduct();
      }

      this.$refs.searchProductInput.setFocus();
    },

    insertProduct() {
      this.products.push(this.form.getValues());

      this.$emit("input", this.products);

      this.resetForm();
    },

    setProductUpdate(index) {
      this.resetForm();

      this.updateIndex = index;

      this.form.setValues(this.products[index]);

      this.$refs.searchProductInput.setFocus();
    },

    updateProduct() {
      /*
       * Abaixo um erro comum *
        https://br.vuejs.org/v2/guide/list.html#Limitacoes
       */

      // Não é reativo
      ////this.products[this.updateIndex] = this.form.getValues()

      // É Reativo
      this.$set(this.products, this.updateIndex, this.form.getValues());

      this.$emit("input", this.products);

      this.resetForm();
    },

    isEan13(val) {
      if (!val) {
        return false;
      }
      return val.match(/^[0-9]+$/) && val.length == 13;
    },

    isEan13Balance(val) {
      if (!val) {
        return false;
      }
      return val[0] == 2;
    },

    productBalanceDescriptionEan13(val) {
      let product_sku = val.substring(1, 7);

      //remover os zeros da esquerda
      product_sku = product_sku.replace(/^0+/, "");
      //  remover os zeros da direita
      product_sku = product_sku.replace(/0+$/, "");

      
      return product_sku;
    },

    quantityBalanceEan13(val) {
      let quantity = val.substring(8, 12);

      let dot = Math.floor(quantity.length - 3);

      var weightDot =
        quantity.substring(0, dot) + "." + quantity.substring(dot);

      this.weight = weightDot;

      return weightDot;
    },

    setProductsData(producstData) {
      this.producstData = producstData;
    },

    resetForm() {
      this.form.reset();

      this.updateIndex = null;

      this.form.quantity.value = 1;
    },
  },
};
</script>

<style lang="scss">
/*.orderProductInputs {

    margin-bottom: 0px;

  }

  .orderProductCell {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }*/
</style>
